import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-extra-properties-field",
  standalone: true,
  imports: [],
  template: "",
})
export class ExtraPropertiesFieldComponent<T = unknown> {
  public key: string;
  public control: FormControl<T | null>;

  public constructor() {
    this.key = "";
    this.control = new FormControl<T | null>(null);
  }
}
